import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

/**
 * Figma 20188:57877 — "Button". Same "Say ..." chip shape as the header's
 * pill (20183:57161 in HeaderWithLogo.tsx) but larger: 17px padding all
 * round, 18px copy, and a slightly dimmer border/fill so it reads as a
 * secondary hint rather than chrome.
 */
const CHIP_PADDING_PX = 17;

type Props = {
  /** The voice command phrase, rendered as `Say "<text>"`. */
  text: string;
  /** Defaults to Figma's `rgba(255, 255, 255, 0.06)`. */
  backgroundColor?: string;
  /** Defaults to Figma's `rgba(255, 255, 255, 0.12)`. */
  borderColor?: string;
};

export function CommandChips({
  text,
  backgroundColor = "rgba(255, 255, 255, 0.06)",
  borderColor = "rgba(255, 255, 255, 0.12)",
}: Props) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "flex-start",
        flexShrink: 0,
        bgcolor: backgroundColor,
        border: "1px solid",
        borderColor,
        borderRadius: "14px",
        p: `${CHIP_PADDING_PX}px`,
      }}
    >
      <Typography
        sx={{
          fontFamily: "var(--font-sans)",
          fontWeight: 500,
          fontSize: "18px",
          lineHeight: "19.5px",
          letterSpacing: "0.13px",
          textAlign: "center",
          whiteSpace: "nowrap",
          color: "rgba(255, 255, 255, 0.55)",
        }}
      >
        Say{" "}
        <Box component="span" sx={{ color: "rgba(255, 255, 255, 0.88)" }}>
          {`"${text}"`}
        </Box>
      </Typography>
    </Box>
  );
}
